module.exports = __webpack_public_path__ + "42a6985be06c8747b8869db85708c7f3.svg";